import React from 'react'
import PropTypes from 'prop-types'
import Helmet from 'react-helmet'
import styled, { css } from "styled-components"
import Typography from "typography";

import Header from '../components/header'
import UnderConstruction from '../components/underConstruction'
import Footer from '../components/footer'
import './index.css'

const sidebarColor = "#0c95ff"
const sidebarWidth = 20
const sidebarMaxWidth = 360
const footerHeight = 120;

const media = (...args) => css`
  @media (min-width: ${100 / sidebarWidth * sidebarMaxWidth}px) {
    ${css(...args)}
  }
`

const Sidebar = styled(Header)`
  width: ${sidebarWidth}vw;
  font-size: 3vw;
  ${media`
    width: ${sidebarMaxWidth}px;
    font-size: ${sidebarMaxWidth / sidebarWidth * 3}px
  `}
`

const MainContent = styled.main`
  margin-left: ${sidebarWidth}vw;
  padding: 10px 20px;
  background-color: #ffffff;
  margin-bottom: ${footerHeight}px;
  min-height: 100vh;
  ${media`
    margin-left: ${sidebarMaxWidth}px;
  `}
`

const Foot = styled(Footer)`
  left: ${sidebarWidth}vw;
  
  ${media`
    left: ${sidebarMaxWidth}px;
  `}
`

const Layout = ({ children, data }) => (
  <div>
    <Helmet
      meta={[
        { name: 'description', content: `Website of ${data.site.siteMetadata.websiteName}` },
        { name: 'author', content: 'Moritz Beck (Birkenstab)' }
      ]}
      htmlAttributes={{"lang": "en"}} 
    />
    <Sidebar lettering={data.site.siteMetadata.websiteName} color={sidebarColor} />
    <MainContent>
      <UnderConstruction />
      {children()}
    </MainContent>
    <Foot color={sidebarColor} height={footerHeight} />
  </div>
)

Layout.propTypes = {
  children: PropTypes.func,
}

export default Layout

export const query = graphql`
  query SiteTitleQuery {
    site {
      siteMetadata {
        websiteName
      }
    }
  }
`



// WEBPACK FOOTER //
// ./src/layouts/index.js